import { Component } from '@angular/core';
import { PresentationConfig } from '../includes/PresentationConfig';
import { SLIDE_FOLDER } from '../includes/Settings';

@Component({
  selector: 'menu',
  templateUrl: './Menu.html',
})
export class MenuComponent {

  public static selectedPresentation: string;
  public config: PresentationConfig;

  constructor() {
    fetch(SLIDE_FOLDER + '/config.json')
      .then((response) => response.json())
      .then((json) => this.config = json);
  }

  public get presentations(): PresentationConfig[] {
    if (!this.config) {
      return null;
    }
    return Object.values(this.config.presentations);
  }

  public selectPresentation(key: string): void {
    MenuComponent.selectedPresentation = key;
  }
}
